
// 进入收银台 去签约/支付
import { store, mutations } from '@/observable/store'
import { toApp } from "@/utils/appBridge";



export default {
  data() {
    return {
      // key: value
    }
  },
  computed: {
    uuid() {
      let uuid = this.$route.query.uuid;
      // 防止存在多个uuid 取第一个。
      if (Array.isArray(uuid)) {
        uuid = uuid[0];
      }
      return uuid
    },
    templateFlag() {
      return this.$route.query.templateFlag;
    },
    outTrade() {
      return this.$route.query.outTrade;
    },
    paySuccessSate() {
      return this.$route.query.paySuccessSate;

    },
    path(){ //不同的支付成功样式
      if(this.templateFlag == 'ht_irok_plus'){
        return '/stencilSuccess'
      }else{
        if (this.paySuccessSate && this.paySuccessSate == "activation") {
          return "/happySuccess"
        }
        return '/paySuccess'
      }
    }
  },
  methods: {
    // 签约
    paySign(data) {

      if (data.entrust_info.has_entrust == 0) { //has_entrust === 0 没有过签约
        
        let parme = {
          order_number: this.outTrade,
          uuid: this.uuid,
          templateFlag: this.templateFlag,
          TXbizKey:store.TXoption.bizKey,
          TXversion:store.TXoption.version
        };
        if (this.CHANNAL_ID == "APP") { //app内签约
          const url = `${window.location.origin}/receiving?order_paramer=${encodeURIComponent(JSON.stringify(parme))}&needRefresh=1`
            
            toApp('signed', {
              signed_id: data.entrust_info.pre_entrustweb_id,
              order_paramer: encodeURIComponent(JSON.stringify(parme)),
              app_success_url:`${window.location.origin}/api/index?sybao=boy&url=${encodeURIComponent(url)}`
            });
          } else {
            if (this.CHANNAL_ID == "JSAPI") { // 公众号签约

              this.$router.replace({
                path: "/receiving",
                query: {
                  isNoApp: true,
                  order_paramer: encodeURIComponent(JSON.stringify(parme)),
                  flag: "postdisable",
                  uri: data.entrust_info.redirect_url,
                  TXbizKey:store.TXoption.bizKey,
                  TXversion:store.TXoption.version
                },
              });
            } else {  //web签约
              this.$router.replace({
                path: "/receiving",
                query: {
                  isNoApp: true,
                  order_number: this.outTrade,
                  uuid: this.uuid,
                  flag: "postdisable",
                  templateFlag: this.templateFlag,
                  uri: data.entrust_info.redirect_url,
                  TXbizKey:store.TXoption.bizKey,
                  TXversion:store.TXoption.version
                },
              });
            }
          }
      }
      // 有签约 直接跳转支付成功 查询支付状态
      if (data.entrust_info.has_entrust == 1) {
        this.$router.replace({
          path: this.path,
          query: {
            uuid: this.uuid,
            flag: "postdisable",
            templateFlag: this.templateFlag,
            outTrade: this.outTrade,
          },
        });
        return;
      }
    },
    // 去支付
    topayTX(data,payFlag) {
      const _this = this
      if (this.CHANNAL_ID == "APP") { //app
        const url = `${window.location.origin}${this.path}?flag=postdisable&uuid=${this.uuid}&templateFlag=${this.templateFlag}&outTrade=${this.outTrade}&TXbizKey=${store.TXoption.bizKey}&TXversion=${store.TXoption.version}` //成功之后回掉
        let parme = {
          pay_type: '3', // 支付宝 1 wx 3
          app_success_url:`${window.location.origin}/api/index?sybao=boy&url=${encodeURIComponent(url)}`, //成功之后回掉
          // app_success_url: `${window.location.origin}${this.path}?flag=postdisable&uuid=${this.uuid}&templateFlag=${this.templateFlag}&outTrade=${this.outTrade}&TXbizKey=${store.TXoption.bizKey}&TXversion=${store.TXoption.version}`, //成功之后回掉
          wx_info: {
            prepayid: data.soyoung.prepay_id,
            nonceStr: data.soyoung.nonce_str,
            // "time_weixin_pay": "prepay_id=wx28171559692969ed66c954191549811400",
            time_weixin_pay: parseInt(data.soyoung.timestamp),
            str_weixin: data.soyoung.str_weixin,
          },
          ali_info: {
            // "expire_time": data.expire_time,
            order_id: data.soyoung.trade_order_id,
            price_deposit: data.soyoung.need_pay,
            title: this.nameOd, // ------需要协商
          },
        };
        console.log('parme',parme);
        toApp("pay", parme);
      } else {
        if (payFlag == 3) {

          if (this.CHANNAL_ID == "MWEB") {

            window.location.href = `${data.wechat.mweb_url
              }&redirect_url=${encodeURIComponent(
                `${window.location.origin}/isPay?uuid=${this.uuid}&templateFlag=${this.templateFlag}&from_action=${store.refid.item_id}&outTrade=${this.outTrade}&ztItemId=${store.refid.zt_item_id}&activityId=${store.refid.activity_id}&paySuccessSate=${this.paySuccessSate}&TXbizKey=${store.TXoption.bizKey}&TXversion=${store.TXoption.version}`
              )}`;
            return;
          }
          wx.ready(function () {
            wx.chooseWXPay({
              timestamp: data.wechat.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.wechat.nonce_str, // 支付签名随机串，不长于 32 位
              package: data.wechat.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType: data.wechat.sign_type, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.wechat.pay_sign, // 支付签名
              success: function (res) {
                _this.$router.replace({
                  path: _this.path,
                  query: {
                    uuid: _this.uuid,
                    flag: "postdisable",
                    templateFlag: _this.templateFlag,
                    outTrade: _this.outTrade,
                    codeNumber:70    // codeNumber --- this.path == '/happySuccess'是需要用到 用来判断 是支付成功还是 领取成功
                  },
                });
                
              },
              fail: function (res) {
                console.log("res----", res);
              },
              cancel: function (res) {
                console.log("支付验证err", res);
              },
            });
          });
          wx.error(function (res) {
            console.log("微信初始化失败", res);
          });
        } else { //其他支付方式 
          if (data.ali_info.auth_url) {

            window.location.href = decodeURIComponent(
              data.ali_info.auth_url
            );
          }
        }
      }
    }
  }
}
